<template>
  <div>
    <h5
      id="9253176579"
      class="fsize24 text-232323 hoverText1 sm-fsize20 font-semibold lg:mt-16 md:mt-12 mt-5 mb-4"
    >
      {{ pageData ? pageData["9253176579"] : "Fire Retardant Series" }}
    </h5>

    <div
      class="lg:mt-8 md:mt-12 mt-4 items-center lg:flex md:flex lg:gap-12 md:gap-10"
    >
      <div
        id="3613102542"
        class="hoverText1 lg:w-1/2 md:w-1/2 w-full img-border md:block mob-hidden"
      >
        <img
          :src="getImage(pageData['3613102542'])"
          alt="acp icon"
          class="h-250 sm-h-350px object-contain m-auto w-2/3"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
        <h6
          id="9820728410"
          class="fsize20 sm-fsize16 hoverText1 font-semibold text-232323 lg:mb-2 md:mb-2 mb-2 lg:mt-0 md:mt-0 mt-4"
        >
          {{ pageData ? pageData["9820728410"] : "EUROBOND FR PLUS" }}
        </h6>
        <div class="lg:w-1/2 md:w-1/2 w-full img-border web-hidden">
          <img
            src="@/assets/images/about/Fire Retardant ACP.png"
            alt="acp icon"
            class="h-250 sm-h-350px object-contain m-auto w-1/2"
          />
        </div>
        <p
          id="6968612785"
          class="hoverText1 fsize18 lg:mt-0 md:mt-0 mt-4 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14"
        >
          {{ pageData ? pageData["6968612785"] : "9452047243" }}
          <span v-if="readMoreFR"></span><span v-else>...</span>
        </p>
        <p
          id="9400545124"
          class="hoverText1 fsize18 lg:mt-0 md:mt-0 mt-4 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14"
          v-show="readMoreFR"
        >
          {{
            pageData
              ? pageData["9400545124"]
              : " EUROBOND FR Plus is also composed of two Aluminium skins (Alloy 3003/5005), the front skin coated with an advanced PVDF/FEVE coating system and the rear with a wash coat to provide the highest life to the panel. The front skin being PVDF/FEVE coated provides excellen colour retention, gloss retention, UV stability, Weathering resistance, and pollution resistance for more than a decade with negligible periodic maintenance. EUROBOND FR PLUS sheets confirm as per EN 13501-1 as Class B - s1 d0 rating, and they have been tested and certified by Exova Warringtonfire, UK. EUROBOND FR Plus has a 3 Hour Fire rating for ASTM E 119, and it has been tested by Thomas Bell Wright, Dubai."
          }}
        </p>
        <p class="cursor-pointer" @click="readMoreFR = !readMoreFR">
          <span
            class="fsize15 sm-fsize14 textsecondary underline hover"
            v-if="readMoreFR"
            >Read less</span
          >
          <span class="fsize15 sm-fsize14 textsecondary underline hover" v-else
            >Read more</span
          >
        </p>
      </div>
    </div>
    <div
      class="lg:mt-16 md:mt-12 mt-5 items-center lg:flex md:flex cust-flex-col-reverse lg:gap-12 md:gap-10"
    >
      <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-0">
        <p
          id="4915241110"
          class="fsize20 hoverText1 sm-fsize16 font-semibold text-232323 lg:mb-2 md:mb-2 mb-2 lg:mt-0 md:mt-0 mt-4"
        >
          {{ pageData ? pageData["4915241110"] : "EUROBOND A2 ACP" }}
        </p>
        <div
          id="4815209211"
          class="hoverText1 lg:w-1/2 md:w-1/2 w-full img-border web-hidden"
        >
          <img
            :src="getImage(pageData['4815209211'])"
            alt="acp icon"
            class="h-250 sm-h-350px object-contain m-auto w-1/2"
          />
        </div>
        <p
          id="6182223395"
          class="hoverText1 fsize18 lg:mt-0 md:mt-0 mt-4 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14 line-clamp-6"
        >
          {{
            pageData
              ? pageData["6182223395"]
              : "EUROBOND A2 ACP sheets are composed of best-in-class materials with a minimum 90% mineral core sandwiched between two aluminium skins of alloy 3003/5005 with Kynar 500 PVDF/FEVE lacquered Surface on the front and service coated on the rear."
          }}
          <span v-if="readMoreA2"></span><span v-else>...</span>
        </p>
        <p
          id="4663092958"
          class="hoverText1 fsize18 lg:mt-0 md:mt-0 mt-4 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14"
          v-show="readMoreA2"
        >
          {{
            pageData
              ? pageData["4663092958"]
              : "The FR Mineral Core of EUROBOND ACP is made of special grade MDH and ATH compounds which are the most Reliable Halogen-Free (HF) compounds, meaning they emit non-toxic harmless vapour upon forced burning, exhibit best flame self-extinguishing behaviour, and are active smoke suppressants. EURBOND A2 ACP sheets don't contribute to the spread of fire at all in the event of a fire accident. EUROBOND FR A2 sheets confirm as per EN 13501-1 as Class A2 - s1 d0 rating and they have been tested and certified by Exova Warringtonfire, UK Laboratories, China. EUROBOND A2 ACP sheets satisfy almost all the building and construction codes worldwide including applications in fields such asrailways, transportation, wind energy, defence, etc."
          }}
        </p>
        <p class="cursor-pointer" @click="readMoreA2 = !readMoreA2">
          <span
            class="fsize15 sm-fsize14 textsecondary underline hover"
            v-if="readMoreA2"
            >Read less</span
          >
          <span class="fsize15 sm-fsize14 textsecondary underline hover" v-else
            >Read more</span
          >
        </p>
      </div>
      <div
        id="4815209211"
        class="hoverText1 lg:w-1/2 md:w-1/2 w-full img-border md:block mob-hidden"
      >
        <img
          :src="getImage(pageData['4815209211'])"
          alt="acp icon"
          class="h-250 sm-h-350px object-contain m-auto w-2/3"
        />
      </div>
    </div>
    <div class="lg:mt-24 md:mt-16 mt-4 items-center lg:flex md:flex gap-12">
      <div
        id="0925263473"
        class="hoverText1 lg:w-1/2 md:w-1/2 w-full img-border md:block mob-hidden"
      >
        <img
          :src="getImage(pageData['0925263473'])"
          alt="acp icon"
          class="h-250 sm-h-350px object-contain m-auto w-2/3"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
        <p
          id="5241692261"
          class="fsize20 hoverText1 sm-fsize16 font-semibold text-232323 lg:mb-2 md:mb-2 mb-2 lg:mt-0 md:mt-0 mt-4"
        >
          {{ pageData ? pageData["5241692261"] : "EUROCORE" }}
        </p>
        <div class="lg:w-1/2 md:w-1/2 w-full img-border web-hidden">
          <img
            src="@/assets/images/about/Aluminium Core Composite Panel.png"
            alt="acp icon"
            class="h-250 sm-h-350px object-contain m-auto w-1/2"
          />
        </div>
        <p
          id="7596025921"
          class="hoverText1 fsize18 lg:mt-0 md:mt-0 lg:mb-4 md:mb-4 mb-4 sm-fsize14 col-3535 line-clamp-6"
        >
          {{
            pageData
              ? pageData["7596025921"]
              : "Eurocore (Aluminium Core Composite Panel) is visually the same as traditional ACP, What makes it different is the innovation in the core technology, replacing the combustible core of ACP with a non-combustible Pure Aluminium Core."
          }}
          <span v-if="readMoreEurocore"></span><span v-else>...</span>
        </p>
        <p
          id="3261989850"
          class="hoverText1 fsize18 lg:mt-0 md:mt-0 lg:mb-4 md:mb-4 mb-4 sm-fsize14 col-3535"
          v-show="readMoreEurocore"
        >
          {{
            pageData
              ? pageData["3261989850"]
              : "Eurocore, along with fire retardance, offers the best strength-to-weight ratio and gives a better edge to the application. Eurocore is much stronger and lighter in unit weight, hence reducing the design load on structures. Eurocore sheets are as formable and construction friendly as regular ACP and are also completely recyclable making them an eco-friendly option. Eurocore sheets are incombustible and very light in weight aiding more and more applications, especially high-rise buildings and constructions."
          }}
        </p>
        <p class="cursor-pointer" @click="readMoreEurocore = !readMoreEurocore">
          <span
            class="fsize15 sm-fsize14 textsecondary underline hover"
            v-if="readMoreEurocore"
            >Read less</span
          >
          <span class="fsize15 sm-fsize14 textsecondary underline hover" v-else
            >Read more</span
          >
        </p>
      </div>
    </div>
    <div
      class="lg:mt-24 md:mt-16 mt-4 lg:mb-20 md:mb-16 mb-5 items-center lg:flex md:flex cust-flex-col-reverse lg:gap-12 md:gap-10"
    >
      <div class="lg:w-1/2 md:w-1/2 w-full lg:mb-0 md:mb-0 mb-4">
        <p
          id="8622079917"
          class="hoverText1 fsize20 sm-fsize16 font-semibold text-232323 lg:mb-2 md:mb-2 mb-2 lg:mt-0 md:mt-0 mt-4"
        >
          {{ pageData ? pageData["8622079917"] : "EUROCOMB" }}
        </p>
        <div class="lg:w-1/2 md:w-1/2 w-full img-border web-hidden">
          <img
            src="@/assets/images/about/Aluminium Honeycomb Panel.png"
            alt="acp icon"
            class="h-250 sm-h-350px object-contain m-auto w-1/2"
          />
        </div>
        <p
          id="1953752134"
          class="hoverText1 lg:mt-0 md:mt-0 fsize18 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14"
        >
          {{
            pageData
              ? pageData["1953752134"]
              : "Eurocomb – Aluminium Honeycomb Panel is a sandwich panel with a honeycomb structure as its core, which is inspired by the natural hexagonal honeycomb. This unique structure makes the panel lightweight compared to other materials of the same volume. It also enhances stiffness and stability. The fact that Eurocomb panels are completely recyclable makes them environment-friendly."
          }}
          <span v-if="readMoreEurobond"></span><span v-else>...</span>
        </p>
        <p
          id="8484615715"
          class="hoverText1 lg:mt-0 md:mt-0 fsize18 lg:mb-4 md:mb-4 mb-4 col-3535 sm-fsize14"
          v-show="readMoreEurobond"
        >
          {{
            pageData
              ? pageData["8484615715"]
              : "And their fire-retardant properties make them the safer choice. With the best quality-control procedures which involve testing through advanced equipment, we are able to add to the trust that our customersplace in us by offering a 15-year warranty on our Eurocomb Panels."
          }}
        </p>
        <p class="cursor-pointer" @click="readMoreEurobond = !readMoreEurobond">
          <span
            class="fsize15 sm-fsize14 textsecondary underline hover"
            v-if="readMoreEurobond"
            >Read less</span
          >
          <span class="fsize15 sm-fsize14 textsecondary underline hover" v-else
            >Read more</span
          >
        </p>
      </div>
      <div
        id="6486007489"
        class="hoverText1 lg:w-1/2 md:w-1/2 w-full img-border md:block mob-hidden"
      >
        <img
          :src="getImage(pageData['6486007489'])"
          alt="acp icon"
          class="h-250 sm-h-350px object-contain m-auto w-2/3"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      readMoreFR: false,
      readMoreA2: false,
      readMoreEurocore: false,
      readMoreEurobond: false,
      isShowCMS: false,
      pageData: {},
      selectedId: "",
      direction: "rtl",
    };
  },
  watch: {
    isShowCMS(newValue) {
      console.log(newValue);
    },
    pages(value) {
      this.pageData = value["FR ACP"];
    },
  },
  computed: {
    ...mapState("cms", ["pages", "user"]),
  },
  methods: {
    getImage(image) {
      if (image && image.includes("data:image/")) {
        return image;
      } else {
        if (image) {
          return `${process.env.VUE_APP_STORAGE_URL}${image}`;
        } else {
          return "https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg";
        }
      }
    },
    async removeClass() {
      let classData = document.getElementsByClassName("hoverText1");

      const elementsArray = Array.from(classData);

      elementsArray.forEach((element) => {
        element.classList.remove("hoverText1");
      });
    },

    addClass() {
      let classData2 = document.getElementsByClassName("hoverText1");

      let classData = document.getElementsByClassName("hoverText1");
      console.log(classData, "home");
      for (let i = 0; i < classData.length; i++) {
        classData[i].classList.add("hoverText1");
        if (classData[i]) {
          console.log(classData[i].id, "ids");
          classData[i].addEventListener("click", () => {
            this.selectedId = classData[i].id;
            console.log(this.selectedId, "selected");
            this.isShowCMS = true;
          });
        }
      }
    },

    async closePopup2() {
      console.log("close");
      this.isShowCMS = false;
      let cms = { projectName: process.env.VUE_APP_COMMUNITY_NAME };
      await this.$store.dispatch("cms/getClientCms", cms);
    },
    init() {
      let popVal = localStorage.getItem("pop");
      let val = Boolean(popVal);
      if (!val) {
        localStorage.setItem("pop", false);
      } else {
        localStorage.setItem("pop", true);
        let pop = localStorage.getItem("pop");
        this.AdPopup = Boolean(pop);
      }
    },
    async closeModal() {
      localStorage.setItem("pop", false);
      this.AdPopup = false;
    },
  },
  async mounted() {
    this.init();
    if (this.pages) {
      this.pageData = this.pages["FR ACP"];
    }

    if (this.$route.query.token === "123") {
      console.log("CMS Active");
      await this.addClass();
    } else {
      await this.removeClass();
    }
  },
};
</script>

<style>
@media (max-width: 640px) {
  .cust-flex-col-reverse {
    display: flex;
    flex-direction: column-reverse;
  }
}
.img-border {
  border: 1px solid #80808026;
}
</style>
